import { useAEMComponentData } from "@AEM/AEMContentLoader"
import { AEMComponentMapper, AEMPageType } from "@AEM/models/AEMPage.model"
import { CurrencyConverter } from "@components/ui/CurrencyConverter/CurrencyConverter"
import { WeatherWidget } from "@components/ui/WeatherWidget/WeatherWidget"
import { Button, Stack, Switch, Text, Title } from "@mantine/core"
import { useWidgetStore } from "@stores/widgetStore"
import { SHOW_WIDGET_CUSTOMIZE_BUTTON } from "@utils/constants.util"
import styles from "./YourExtensions.module.css"

export function YourExtensions() {
	const { componentData } = useAEMComponentData(
		AEMPageType.DICTIONARY,
		AEMComponentMapper.APP_DICTIONARY
	)
	const { isEditMode, widgetSettings, toggleEditMode, toggleWidget } =
		useWidgetStore()

	return (
		componentData && (
			<Stack gap="lg" justify="space-between" pt={0} pb="xl" px="xl" h="100%">
				{isEditMode ? (
					<Stack>
						<Title size="sm" fw={600}>
							{componentData?.widgetCustomizeIntro}
						</Title>
						<Stack gap="xs">
							<Switch
								checked={widgetSettings.weather}
								onChange={() => toggleWidget("weather")}
								label={componentData?.widgetWeatherTitle}
								size="md"
								classNames={{
									track: widgetSettings.weather
										? styles.switchTrackChecked
										: styles.switchTrackUnchecked,
									thumb: styles.switchThumb
								}}
							/>
							<Text size="xs" c="var(--text-color-grey)" ml={58}>
								{componentData?.widgetWeatherIntro}
							</Text>
							<Switch
								checked={widgetSettings.currencyConverter}
								onChange={() => toggleWidget("currencyConverter")}
								label={componentData?.widgetcurrencyTitle}
								size="md"
								classNames={{
									track: widgetSettings.currencyConverter
										? styles.switchTrackChecked
										: styles.switchTrackUnchecked,
									thumb: styles.switchThumb
								}}
							/>
							<Text size="xs" c="var(--text-color-grey)" ml={58}>
								{componentData?.widgetCurrencyIntro}
							</Text>
						</Stack>
					</Stack>
				) : (
					<Stack>
						{widgetSettings.weather && <WeatherWidget />}
						{widgetSettings.currencyConverter && <CurrencyConverter />}
					</Stack>
				)}

				{SHOW_WIDGET_CUSTOMIZE_BUTTON && (
					<Stack align="center">
						<Button variant="dark-blue" size="lg" onClick={toggleEditMode}>
							{isEditMode
								? componentData?.widgetSaveButton
								: componentData?.widgetCustomizeButton}
						</Button>
					</Stack>
				)}
			</Stack>
		)
	)
}
